import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { useTranslation } from 'react-i18next';

export const DealTroubleshootingStateLoading = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ marginTop: 6 }} data-test="troubleshooting-state-loading">
      <Typography variant="h3">{t('Retrieving data')}</Typography>

      <Typography variant="body1" sx={{ color: theme => theme.palette.text.secondary, marginTop: 0.5 }}>
        {t('Please wait while the breakout is generated.')}
      </Typography>

      <Box sx={{ marginTop: 3, width: 55 }}>
        <Loader noPadding />
      </Box>
    </Box>
  );
};
